<script setup lang="ts">
import { RouterLink } from 'vue-router';

const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="border-t border-border bg-card">
    <div class="max-w-4xl mx-auto px-4 py-8">
      <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div class="text-sm text-muted-foreground">
          &copy; {{ currentYear }} LLM-SR
        </div>
        <nav class="flex items-center gap-6">
          <RouterLink
            to="/how-it-works"
            class="text-sm text-muted-foreground hover:text-foreground transition"
          >
            How it Works
          </RouterLink>
          <RouterLink
            to="/privacy"
            class="text-sm text-muted-foreground hover:text-foreground transition"
          >
            Privacy
          </RouterLink>
        </nav>
      </div>
    </div>
  </footer>
</template>
